'use client';
import { convertLabelToKey } from '@/shared/utils';
import { Button } from 'components/ui/button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ProviderInformationTabs({ provider }) {
  const { t } = useTranslation();

  const { LocatorServicesProvided: services } = provider;

  const [tab, setTab] = useState(services[0]?.Services?.name);
  const tabs = services?.map(
    (service: { Services: { name: string } }) => service.Services?.name
  );

  const getTextFromService = (tab: string) => {
    return (
      services.find((service) => service.Services?.name === tab)?.text || ''
    );
  };

  return (
    <div className="flex flex-col gap-0">
      <div className="inline-flex w-full overflow-x-auto m-0 p-0">
        {tabs?.map((label: string) => (
          <Button
            key={label}
            variant="tab"
            aria-selected={tab === label}
            onClick={() => setTab(label)}
          >
            {t(convertLabelToKey(label))}
          </Button>
        ))}
      </div>
      <div className="bg-white rounded-md rounded-tl-none py-12 px-6 flex flex-col gap-8">
        <div className="flex flex-col gap-8">
          <span
            className="text-[#53565a] text-base font-thin leading-7 whitespace-pre-line break-words inline-block"
            dangerouslySetInnerHTML={{
              __html: getTextFromService(tab)
            }}
          />
        </div>
      </div>
    </div>
  );
}
